module.exports = __webpack_public_path__ + "img/pic22.0efdb109.png";